import { BreakPointCondition, SliderModal, useBreakpointIf } from '@genial/components';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import React from 'react';

import {
  SignedInNavigationScreenNavigationProp,
  SignedInRootStackParamList,
} from '../../routes/types';

import { TransferHistoryContent } from './components/TransferHistoryContent';

export const SecuritiesTransferHistoryModal: React.FC = () => {
  const { params } =
    useRoute<RouteProp<SignedInRootStackParamList, 'SecuritiesTransferHistoryModal'>>();
  const { goBack, canGoBack, navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const handleClose = () => {
    if (canGoBack()) {
      return goBack();
    }
    navigate('Customers', {});
  };

  return (
    <SliderModal onDismiss={handleClose} width={isTablet ? 1 : 0.4}>
      <TransferHistoryContent {...params} onClose={handleClose} />
    </SliderModal>
  );
};
